import * as React from "react";
import {OnSortHandler, SortState} from "../../../../utils/Sort";
import User from "../../../../model/User";
import {generateRoute, goToRoute} from "../../../../utils/Router";
import {ROUTE_ADMIN_USER_DETAIL} from "../../../../routing/Routes";
import Th from "../../../../components/table/Th";
import I18nUtils from "../../../../I18n/I18nUtils";
import {TR_APELLIDO, TR_EMAIL, TR_NOMBRE} from "../../../../I18n/constants";

interface UserListTableProps {
    data: User[],
    error: string,
    onSort: OnSortHandler,
    sort: SortState,
    renderSelectTd?: (itemId: string) => React.ReactNode,
}

export default class UserListTable extends React.Component<UserListTableProps> {

    private goToItemDetail = (itemId: string): void => {
        goToRoute(generateRoute(ROUTE_ADMIN_USER_DETAIL, {id: itemId}))
    };

    public render(): React.ReactNode {
        const {data, renderSelectTd} = this.props;

        return (
            <table className="table table-hover">
                <thead>{this.renderTH()}</thead>
                <tfoot>{this.renderTH()}</tfoot>
                <tbody>
                {data && data.map((user: User) => {
                    return (
                        <tr key={user.id}
                            onClick={() => this.goToItemDetail(user.id)}
                            className={"tr-cursor"}
                        >
                            {renderSelectTd ? renderSelectTd(user.id) : null}
                            <td>
                                {user.name}
                            </td>
                            <td>{user.last_name ? user.last_name : ''}</td>
                            <td>{user.email}</td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
        )
    }

    private renderTH(): React.ReactNode {
        const {sort, children, onSort} = this.props;
        const commonProps = {
            sort,
            onSort
        };

        return (
            <tr>
                {children}
                <Th text={I18nUtils.tr(TR_NOMBRE)}
                    columnName={'name'}
                    {...commonProps}
                />
                <Th text={I18nUtils.tr(TR_APELLIDO)}
                    columnName={'last_name'}
                    {...commonProps}
                />
                <Th text={I18nUtils.tr(TR_EMAIL)}
                    columnName={'email'}
                    {...commonProps}
                />
            </tr>
        )
    }
}